/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  UserRequest,
  SignInRequest,
} from "../models/userRequestResponse.interface";
import { API_PATH } from "../../../../environments/config";
import { BehaviorSubject } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};
@Injectable({
  providedIn: "root",
})
export class SignInService {
  constructor(private http: HttpClient) {}

  forgotPasswordDataPass: BehaviorSubject<any> = new BehaviorSubject({});
  changePasswordDataPass: BehaviorSubject<any> = new BehaviorSubject({});
  public signIn(signInRequest: SignInRequest, isSrsm?) {
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);
    let data = {};
    data = signInRequest;
    if (isSrsm) {
      data["localCode"] = "SRSM";
    }
    return this.http.post<UserRequest>(
      `${API_PATH.apis.signin}`,
      data,
      httpOptions
    );
  }

  public sendOTP(request: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);

    return this.http.post<UserRequest>(
      `${API_PATH.apis.sendOTP}`,
      request,
      httpOptions
    );
  }

  public verifyOTP(request: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);

    return this.http.post<UserRequest>(
      `${API_PATH.apis.sendOTP}`,
      request,
      httpOptions
    );
  }

  public changePassword(request: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);

    return this.http.post<UserRequest>(
      `${API_PATH.apis.sendOTP}`,
      request,
      httpOptions
    );
  }

  public updatePassword(request: any) {
    return this.http.post<UserRequest>(
      `${API_PATH.apis.changePassword}`,
      request,
      httpOptions
    );
  }

  public updateUserInfo(request: any) {
    // const sessionId: string = this.cookieService.get('SESSIONID');
    // httpOptions.headers = httpOptions.headers.set('Authorization', sessionId);

    return this.http.put<UserRequest>(
      `${API_PATH.apis.userProfileUpdate}`,
      request,
      httpOptions
    );
  }

  sendUserDataFromSignInPage(data: any) {
    this.forgotPasswordDataPass.next(data);
  }
  sendUserDataFromProfilePage(data: any) {
    this.changePasswordDataPass.next(data);
  }
  getCurrentUserData() {
    return this.http.post<UserRequest>(`${API_PATH.apis.userProfileData}`, {});
  }
  updateCurrentUserData(data) {
    return this.http.put<UserRequest>(
      `${API_PATH.apis.userProfileUpdate}`,
      data
    );
  }
}
